module.exports = __webpack_public_path__ + "img/img-header.16c8356.webp";